import { Row, Col } from "react-bootstrap";
import tick from "../assets/img/Tick.svg";

export const KeyPoint = () => {
  return (
    <section className="keypoint" id="keypoint">
      <Row className="row-width">
        <Col xs={12} md={6} xl={3}>
          <div className="keypointspoints">
            <div className="column1keypoint">
              <img src={tick} alt="Tick"></img>
            </div>
            <div className="column2keypoint">
              <p>100% Free Consultation</p>
            </div>
          </div>
        </Col>
        <Col xs={12} md={6} xl={3}>
          <div className="keypointspoints">
            <div className="column1keypoint">
              <img src={tick} alt="Tick"></img>
            </div>
            <div className="column2keypoint">
              <p>Healthcare for Every Budget</p>
            </div>
          </div>
        </Col>
        <Col xs={12} md={6} xl={3}>
          <div className="keypointspoints">
            <div className="column1keypoint">
              <img src={tick} alt="Tick"></img>
            </div>
            <div className="column2keypoint">
              <p>No Hidden Costs</p>
            </div>
          </div>
        </Col>
        <Col xs={12} md={6} xl={3}>
          <div className="keypointspoints">
            <div className="column1keypoint">
              <img src={tick} alt="Tick"></img>
            </div>
            <div className="column2keypoint">
              <p>No Commitments Required</p>
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};
